/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Table, TableColumnsType} from "antd";
import dayjs from "dayjs";
import styles from './RightList.module.scss';
import { JobHistoryInterface } from '../SystemBatchRun.interface';
import {formatKorDate} from "../../../util/date";
import ColumnSubText from "../../../components/common/table/cell/ColumnSubText";
import SimplePaging from "../../../components/common/paging/SimplePaging";

interface RightListProps {
	data: JobHistoryInterface[];
	currentPage: number;
	changeCurrentPage: (value: number) => void;
}

const RightList = ({data, currentPage, changeCurrentPage}: RightListProps) => {

	const columns: TableColumnsType<JobHistoryInterface> = [
		{
			title: '시작',
			dataIndex: 'createDate',
			key: 'createDate',
			width: 150,
			align: 'center',
			render: (text: string) => (
				<div style={{ textAlign: 'left' }}>
					<div>{formatKorDate(text)}</div>
					<ColumnSubText text={dayjs(text).format('HH:mm')}/>
				</div>
			),
		},
		{
			title: '종료',
			dataIndex: 'endDate',
			key: 'endDate',
			width: 150,
			align: 'center',
			render: (text: string) => (
				<div style={{ textAlign: 'left' }}>
					<div>{formatKorDate(text)}</div>
					<ColumnSubText text={dayjs(text).format('HH:mm')}/>
				</div>
			),
		},
		{
			title: '작업자',
			dataIndex: 'createUser',
			key: 'createUser',
			width: 150,
			align: 'center',
		},
		{
			title: 'Job ID',
			dataIndex: 'jobId',
			key: 'jobId',
			width: 150,
			align: 'center',
		},
		{
			title: '상태',
			dataIndex: 'status',
			key: 'status',
			width: 150,
			align: 'center',
			render: (text: string) => {
				let color = '';
				if (text === 'active') color = '#007BFF';
				else if (text === 'completed') color = '#28A745';
				else if (text === 'failed') color = '#DC3545';
				let textKoStr = '';
				if(text === 'active') textKoStr = '진행중';
				if(text === 'completed') textKoStr = '성공';
				if(text === 'failed') textKoStr = '실패';
				return (
					<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<span style={{ color, marginRight: '4px' }}>●</span>
						<div>{textKoStr}</div>
					</div>
				);
			},
		},

		{
			title: '오류',
			dataIndex: 'errMsg',
			key: 'errMsg',
			align: 'center',
			render: (text: string) => (
				<div style={{ textAlign: 'left' }}>
					{text}
				</div>
			)
		},
	];

	return (
		<>
			<div className={styles.tableWrap}>
				<Table<JobHistoryInterface>
					size="small"
					bordered
					columns={columns}
					dataSource={data.map(row => ({ ...row, key: row.id }))}
					pagination={false}
				/>
			</div>
			<div className={styles.simplePagingWrap}>
				<SimplePaging
					currentPage={currentPage}
					dataLength={data.length}
					onClickPrePageBtn={() => changeCurrentPage(-1)}
					onClickNextPageBtn={() => changeCurrentPage(1)}
				/>
			</div>
		</>
	);
};

export default RightList;